import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Flex, ListBox, Item, View, ProgressCircle} from '@adobe/react-spectrum';
import { CircleFill, ChevronDown, ChevronUp } from 'react-bootstrap-icons';
import { useTranslation } from 'react-i18next';
import styles from './item_status_filter_component.module.css';
import { usePreloadAssets } from '../../../../hooks/UsePreloadAssets';
import { useViewInfo } from '../../../../hooks/UseViewInfo';
import { statusColor, truncateText } from '../../../../utils/helperUtil';
import { useDependency } from '../../../../contexts/DependencyProvider';
import { ListItemStatusRequest } from '../../../../services/soap/item/requests/ListItemStatusRequest';

interface ItemStatusFilterComponentProps {
  createParams: (filterType: any, filterValue: any) => void;
  filterParams?: any;
  clearFilters?:boolean
}

const ItemStatusFilterComponent: React.FC<ItemStatusFilterComponentProps> = ({ createParams, filterParams,clearFilters }) => {
  const { isMobile } = useViewInfo();
  const { t } = useTranslation('products');
  const _t = (key: string) => t(`product_filters.${key}`, { ns: 'products' });
  const {industries} = usePreloadAssets();
  const {store,itemService} = useDependency();
  const [toggleListVisibility, setToggleListVisibility] = useState<any>({ stateList: true });
  const [selectedItemStatusKey, setSelectedItemStatusKey] = useState<Set<string>>(new Set(['All status']));
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [itemStatusList, setItemStatusList] = useState<any[]>([]);
  const productStatusList = useRef<any>([]);
  
  const handleSelectionChange = (value: any) => {
    const arrValue = Array.from(value);
    const filteredValue = arrValue.filter(item => item !== 'All status');
    const updateValue = filteredValue.length > 0 ? new Set(filteredValue) : new Set(['All status']);
    setSelectedItemStatusKey(new Set(Array.from(updateValue).map(String)));
    createParams('status', updateValue)
  };

  const getItemStatus = async () => {
  setShowLoader(true);
  const statusArray: any[] = [];
  const request = await itemService.listItemStatus(new ListItemStatusRequest(store.Server, store.SessionId));

  if (request.result === "OK") {
    request.ITEM_STATUS.forEach((status: any) => {
      const { id, name } = status;

      // Generate a random number between 1 and 16777215 (0xFFFFFF)
      const randomNumber = Math.floor(Math.random() * 16777215) + 1;

      // Convert it using your statusColor function
      const colorString = statusColor(randomNumber.toString());

      statusArray.push({ id, name, color: colorString });
    });
    productStatusList.current = statusArray;
    setShowLoader(false);
  }
};


  useEffect(() => {
    getItemStatus();
  }, []);

  useEffect(() => {
    if(clearFilters){
      setSelectedItemStatusKey(new Set(['All status']));
    }
  }, [clearFilters]);

  if (showLoader) {
    return (
      <Flex width="100%" height="100%" UNSAFE_style={{ backgroundColor: 'white' }} justifyContent={'center'} alignContent={'center'} alignItems={'center'}>
        <ProgressCircle aria-label="Loading…" isIndeterminate />
      </Flex>
    );
  } else {
    return (
      <Flex direction={'column'} minWidth={'200px'} marginTop={'15px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'}>
        <Flex direction={'column'} gap={'4px'} alignSelf={'stretch'} alignItems={'start'} justifyContent={'start'} UNSAFE_className={styles.ItemStatus_container}>
          <Flex direction={'row'} height={'36px'} alignSelf={'stretch'} alignItems={'center'} justifyContent={'space-between'} UNSAFE_className={styles.industry_heading}>
            <Flex direction={'row'} flex={1} alignItems={'center'} justifyContent={'start'}>
              <View position={'relative'} UNSAFE_className={styles.industry_heading_text}>
                {_t('search_by_states')}
              </View>
            </Flex>

            {toggleListVisibility.stateList ? (
              <ChevronDown color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: false }))} style={{ cursor: 'pointer' }} />
            ) : (
              <ChevronUp color="#B0BEC5" onClick={() => setToggleListVisibility((preValue: any) => ({ ...preValue, stateList: true }))} style={{ cursor: 'pointer' }} />
            )}
          </Flex>
          <Flex
            direction={'column'}
            alignSelf={'stretch'}
            alignItems={'start'}
            justifyContent={'start'}
            UNSAFE_className={isMobile ? styles.industry_component_mobile : styles.industry_component}
            UNSAFE_style={{ display: toggleListVisibility.stateList ? '' : 'none' }}
          >
            <ListBox
                          id="listActivityStatus"
                          width="100%"
                          selectionMode="single"
                          selectedKeys={selectedItemStatusKey}
                          items={productStatusList.current}
                          onSelectionChange={(value: any) => {
                            handleSelectionChange(value);
                          }}
                          UNSAFE_style={{ color: '#455a64 !important' }}
                          aria-label="none"
                        >
                          {(item: any) => (
                            <Item key={item.id} textValue={truncateText(item.name, 18)}>
                              <Flex direction={'row'} height={'30px'} UNSAFE_style={{ paddingBottom: '30px' }}>
                                <View>
                                  <CircleFill style={{ paddingRight: '10px', paddingTop: '6px' }} size={'18px'} color={item.color} />
                                </View>
                                <View UNSAFE_style={{ whiteSpace: 'nowrap', color: '#455a64 !important', lineHeight: '30px' }}>
                                  <span title={item.name}>{truncateText(item.name, 18)}</span>
                                </View>
                              </Flex>
                            </Item>
                          )}
                        </ListBox>
          </Flex>
        </Flex>
      </Flex>
    );
  }
};

export default ItemStatusFilterComponent;
